/**
 * If you pass stayInDom as true instead of returning null 
 * when component is not shown it will wrap it in a div
 * with display: none 
 */
import React from "react";
import { Subscribe } from "unstated";

import StateContainer from "../../state/StateContainer";

function DisplayWrapper(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(state2) => (
        <React.Fragment>
          {state2.state[props.displayParameter] ? (
            props.children
          ) : props.stayInDom ? (
            <div style={{ display: "none" }}>{props.children}</div>
          ) : null}
        </React.Fragment>
      )}
    </Subscribe>
  );
}

export default DisplayWrapper;
